import { axios } from '@/utils/axios';
import { Blog } from '@/resource/blog/blog.model';

export async function addBlog(params: Blog): Promise<any> {
  const { data } = await axios.post(
    'blogs',
    { ...params },
    { responseType: 'json' },
  );
  return data;
}

export async function updateBlog(uuid: string, params: Blog): Promise<any> {
  const { data } = await axios.put(
    'blogs/' + uuid,
    { ...params },
    { responseType: 'json' },
  );
  return data;
}

export async function publishBlog(uuid: string): Promise<Blog> {
  const { data } = await axios.put('blogs/' + uuid + '/publish', {
    responseType: 'json',
  });
  return data;
}

export async function unpublishBlog(uuid: string): Promise<Blog> {
  const { data } = await axios.put('blogs/' + uuid + '/unpublish', {
    responseType: 'json',
  });
  return data;
}

export async function deleteBlog(uuid: string): Promise<any> {
  const { data } = await axios.delete('blogs/' + uuid, {
    responseType: 'json',
  });
  return data;
}

export async function getAllBlogs(): Promise<Blog[]> {
  const { data } = await axios.get('blogs/admin');
  return data;
}

export async function getBlogByUuid(uuid: string): Promise<Blog> {
  const { data } = await axios.get('blogs/' + 'admin/' + uuid);
  return data;
}
